import type { ReactNode } from "react";
import { PayoutsFrame, type PayoutsTab } from "./components/PayoutsFrame";

export interface AccountPayoutsManageViewProps {
  /** Fresh AccountSession client_secret rendered server-side. */
  initialClientSecret: string;
  /** Stripe publishable key for the embedded Connect components. */
  publishableKey: string;
  /** Refreshes the AccountSession client_secret before it expires. */
  fetchRefreshedClientSecret: () => Promise<string>;
  /** Localized tab definitions for the payouts sub-nav. */
  tabs: PayoutsTab[];
  /** Embedded Stripe Connect components for the manage tab. */
  children: ReactNode;
}

/**
 * Presentational shell for the Payouts › Manage tab. Composes the shared
 * `PayoutsFrame` sub-nav around the embedded Stripe Connect components handed
 * in as children. All Inertia / router / session-refresh wiring lives in the
 * container, which passes it down as plain props.
 */
export function AccountPayoutsManageView({
  initialClientSecret,
  publishableKey,
  fetchRefreshedClientSecret,
  tabs,
  children,
}: AccountPayoutsManageViewProps) {
  return (
    <PayoutsFrame
      currentTab="manage"
      fetchRefreshedClientSecret={fetchRefreshedClientSecret}
      initialClientSecret={initialClientSecret}
      publishableKey={publishableKey}
      tabs={tabs}
    >
      {children}
    </PayoutsFrame>
  );
}
